<template>
  <search-group title="" @search="findData" @clear="clearValue" :span="24" :btnOffset="15" :btnSpan="6" :multipleLines="false" :inline="true" >
    <Row class="mb16" :gutter="16">

      <Col span="6">
        <DatePicker style="width:100%" v-model="searchData.createTime"  split-panels type="daterange" format="yyyy-MM-dd" placeholder="创建日期筛选"></DatePicker>
      </Col>
      <Col span="6">
        <Input v-model="searchData.keyWord" placeholder="请输入业绩公式、创建人"></Input>
      </Col>

    </Row>
  </search-group>
</template>

<script type="text/ecmascript-6">
  import SearchGroup from 'components/SearchGroup/index';
  import {formatDateTime} from "../../../../../utils/format";

  export default {
    components: {
      SearchGroup
    },
    mounted(){
      this.$emit('searchData', this.searchDataComputed);
  },
    computed:{
      searchDataComputed(){
        function f(data) {
          return data?formatDateTime(data, false):''
        }
        return {
          keyWord:this.searchData.keyWord,
          beginDate: f(this.searchData.createTime[0]),
          endDate:f(this.searchData.createTime[1])
        }
      }

    },
    data () {
      return {
        searchData: {
          keyWord:'',
          createTime: ['', '']
        },
      }
    },
    methods: {
      findData() {
        this.$emit('searchData', this.searchDataComputed);
      },
      clearValue() {
        this.searchData={
          keyWord:'',
          createTime: ['', '']
        }
      },
    },
  }
</script>

<style scoped>
  .width3{
    width: 200px;
  }
</style>
